import React from 'react';

import LoadingOverlay from 'components/LoadingOverlay';
import { Step } from 'components/SteppedModal';
import { ThreadsPostModalSteps } from './types';

const useAuthenticationProgressStep = (): Step<ThreadsPostModalSteps> => {
  return {
    id: 'authentication-in-progress',
    title: 'Authenticating with Threads',
    fluidFooterButtons: true,
    hideFooter: true,
    component: <LoadingOverlay small />,
  };
};

export default useAuthenticationProgressStep;
